import React, { useEffect, useRef, useState } from 'react';

const steps = [
    {
        number: '01',
        icon: 'ri-search-eye-line',
        title: 'Understand the Problem',
        description: 'Deep-dive into domain knowledge, stakeholder needs, and data reality before touching any code.',
    },
    {
        number: '02',
        icon: 'ri-flashlight-line',
        title: 'Prototype Fast',
        description: 'Rapid experiments with notebooks, quick APIs, and throwaway UIs to validate assumptions early.',
    },
    {
        number: '03',
        icon: 'ri-rocket-line',
        title: 'Ship to Production',
        description: 'Clean architecture, CI/CD, containerisation, and monitored deployments on real infrastructure.',
    },
    {
        number: '04',
        icon: 'ri-pulse-line',
        title: 'Measure & Iterate',
        description: 'Instrument everything. Use metrics and user feedback to close the loop and improve continuously.',
    },
];

const Process = () => {
    const [visible, setVisible] = useState([]);
    const refs = useRef([]);

    useEffect(() => {
        const observers = refs.current.map((el, i) => {
            if (!el) return null;
            const obs = new IntersectionObserver(
                ([entry]) => {
                    if (entry.isIntersecting) {
                        setVisible(prev => prev.includes(i) ? prev : [...prev, i]);
                        obs.disconnect();
                    }
                },
                { threshold: 0.25 }
            );
            obs.observe(el);
            return obs;
        });
        return () => observers.forEach(o => o && o.disconnect());
    }, []);

    return (
        <section className="process section" id="process">
            <div className="container">
                <h2 className="section__title-1">
                    <span>How I Work</span>
                </h2>

                <div className="process__pipeline">
                    {steps.map((step, i) => (
                        <React.Fragment key={i}>
                            <div
                                className={`process__step${visible.includes(i) ? ' process__step--visible' : ''}`}
                                ref={el => refs.current[i] = el}
                                style={{ transitionDelay: `${i * 120}ms` }}
                            >
                                <div className="process__number">{step.number}</div>
                                <div className="process__icon-wrap">
                                    <i className={step.icon}></i>
                                </div>
                                <h3 className="process__title">{step.title}</h3>
                                <p className="process__desc">{step.description}</p>
                            </div>

                            {/* Connector between steps (not after last) */}
                            {i < steps.length - 1 && (
                                <div className={`process__connector${visible.includes(i) ? ' process__connector--visible' : ''}`} aria-hidden="true">
                                    <div className="process__connector-line"></div>
                                    <i className="ri-arrow-right-s-line process__connector-arrow"></i>
                                </div>
                            )}
                        </React.Fragment>
                    ))}
                </div>
            </div>
        </section>
    );
};

export default Process;
